import React, { useState } from "react";
import RulesBoxDescription from "../RulesBoxDescription/RulesBoxDescription";

export default function RulesBox({ children, heading, svg, bgColor }) {
  const [showDetails, setShowDetails] = useState(false);
  // bgColor -> rgba with opacity
  const hexToRgba = (opacity = 0.1) => {
    let r = 0,
      g = 0,
      b = 0;
    if (!bgColor) return;
    // Expand shorthand form (#03F → #0033FF)
    if (bgColor.length === 4) {
      r = parseInt(bgColor[1] + bgColor[1], 16);
      g = parseInt(bgColor[2] + bgColor[2], 16);
      b = parseInt(bgColor[3] + bgColor[3], 16);
    } else if (bgColor.length === 7) {
      r = parseInt(bgColor[1] + bgColor[2], 16);
      g = parseInt(bgColor[3] + bgColor[4], 16);
      b = parseInt(bgColor[5] + bgColor[6], 16);
    }

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  return (
    <>
      <div
        onClick={() => setShowDetails(true)}
        className="px-[8px] py-[12px] bg-[#262626] rounded-[6px] cursor-pointer flex items-center flex-col"
        style={{
          backgroundColor: hexToRgba(0.25),
        }}
      >
        <div>
          <img src={svg} />
        </div>
        <p className="text-smallest-bold mt-[10px] text-center capitalize">
          {heading}
        </p>
      </div>
      {showDetails && (
        <RulesBoxDescription
          children={children}
          setPopup={setShowDetails}
          heading={heading}
        />
      )}
    </>
  );
}
